import React from 'react';
import { ReactComponent as Icon } from './../../../../asset/icons/male.svg';

const IconMale = () => {
  return <Icon></Icon>;
};

export default IconMale;
